import { useEffect, useState } from "react";
import classes from "./Css2.module.css";
import promix from "../../Assets/Promix.svg";
import back from "../../Assets/back.svg";
import search from "../../Assets/search.svg";
import { Search, Calculator, Download, Upload, Plus } from "lucide-react";

const Onboard = () => {
  const [selectedCount, setSelectedCount] = useState(0);
  const accounts = [
    { id: 1000, name: "Cash at Bank", group: "Current Assets" },
    { id: 1100, name: "Petty Cash", group: "Current Assets" },
    { id: 1200, name: "Accounts Receivable", group: "Current Assets" },
  ];
  // Count once on mount
  useEffect(() => {
    setSelectedCount(accounts.length); // All are pre-checked
  }, []);
  // These can be selected/deselected
  const optionalAccounts = [
    { id: 1300, name: "Prepaid Expenses", group: "Current Assets" },
    { id: 1500, name: "Equipment", group: "Fixed Assets" },
    { id: 1600, name: "Furniture & Fixtures", group: "Fixed Assets" },
  ];
  const requiredLiabilities = [
    { id: 2000, name: "Accounts Payable", group: "Current Liabilities" },
    { id: 2100, name: "VAT Payable", group: "Current Liabilities" },
    { id: 2200, name: "Accrued Expenses", group: "Current Liabilities" },
  ];

  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <p className={classes.scythe}>Set Up Your Chart of Accounts</p>
      <p className={classes.knight}>
        Select the accounts that match your business needs
      </p>

      <div className={classes.contor}>
        <div className={classes.cmyk}>
          <div className={classes.cyntheir}>FinConne Technovation Limited</div>
          <div className={classes.cotton}>
            <img src={back} />
            <div className={classes.back}>Back</div>
          </div>
        </div>

        <div className={classes.container}>
          <div className={classes.leftGroup}>
            <div className={classes.searchWrapper}>
              <Search className={classes.searchIcon} />
              <input
                type="text"
                placeholder="Search accounts..."
                className={classes.searchInput}
              />
            </div>
            <span className={classes.selectedText}>
              {selectedCount} accounts selected
            </span>{" "}
          </div>

          <div className={classes.rightGroup}>
            <button
              className={classes.outlineGreen}
              onClick={() => setShowModal(true)}
            >
              <Calculator size={16} />
              Trial Balance
            </button>

            <button className={classes.outlineGreen}>
              <Download size={16} />
              Template
            </button>

            <button className={classes.outlineGreen}>
              <Upload size={16} />
              Upload CSV
            </button>

            <button className={classes.filledGreen}>
              <Plus size={16} />
              Add Custom Account
            </button>
          </div>
        </div>

        <div className={classes.modalOverlay}>
          <div className={classes.modal}>
            <div className={classes.summarySection}>
              <div className={classes.cardGreen}>
                <p>Total Credits</p>
                <h3>₦8,400,000.00</h3>
              </div>
              <div className={classes.cardBlue}>
                <p>Total Debits</p>
                <h3>₦4,950,000.00</h3>
              </div>
              <div className={classes.cardYellow}>
                <p>Differences</p>
                <h3>₦3,200,000.00</h3>
              </div>
              <div className={classes.cardYellow1}>
                <button className={classes.autoBalance}>Auto Balance</button>
              </div>
            </div>

            <div className={classes.alertBox}>
              <span>⚠️</span> Trial Balance Out of Balance
              <p>
                Your total debits (₦12,200,000) don't equal your total credits
                (₦14,000,000). Adjust the balances or use Auto Balance to
                automatically adjust to the nearest equity account.
              </p>
            </div>

            <table className={classes.table}>
              <thead>
                <tr>
                  <th>Account code</th>
                  <th>Account Name</th>
                  <th>Type</th>
                  <th>Balance</th>
                  <th>Debit/Credit</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "Assets",
                    balance: "₦2,500,000.00",
                    mode: "Credit",
                  },
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "Assets",
                    balance: "₦2,500,000.00",
                    mode: "Debit",
                  },
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "liabilities",
                    balance: "₦2,500,000.00",
                    mode: "Debit",
                  },
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "Assets",
                    balance: "₦2,500,000.00",
                    mode: "Debit",
                  },
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "Assets",
                    balance: "₦2,500,000.00",
                    mode: "Credit",
                  },
                  {
                    code: "INV-001",
                    name: "Cash at Bank",
                    type: "Assets",
                    balance: "₦2,500,000.00",
                    mode: "Credit",
                  },
                ].map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.code}</td>
                    <td>{item.name}</td>
                    <td>{item.type}</td>
                    <td>{item.balance}</td>
                    <td>
                      <span
                        className={
                          item.mode === "Credit"
                            ? classes.credit
                            : classes.debit
                        }
                      >
                        {item.mode}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className={classes.footer}>
              <button
                className={classes.back}
                onClick={() => setShowModal(false)}
              >
                ← Back
              </button>
              <button className={classes.save}>📄 Save Trial Balance</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboard;
